
import React, { Component } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import styled from 'styled-components';

import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import AddOutlinedIcon from '@material-ui/icons/AddOutlined';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import { withAsync } from './withAsync';
import { isString, isNumber } from "lodash";

const StyledAutocomplete = styled(Autocomplete)`
  .MuiTextField-root {
    margin-bottom: 0;
  }
`;


export class AutocompleteWidget extends Component {

  static defaultProps = {
    optionLabel: 'name'
  };

  constructor(props) {
    super(props);

    this.state = {
      isOpen: false
    }
  }

  handleChange = (e, newValue) => {
    const { onChange } = this.props;
    onChange(newValue);
  };

  handleOptionSelected = (option, value) => {
    if (value)
      return option.id === value.id;
  };

  getOptionLabel = (option) => {
    const { optionLabel } = this.props;
    if (option && option[optionLabel]) {
      return option[optionLabel];
    }
    return '';
  };

  handleClose = () => {
    this.setState({
      isOpen: false
    })
  };

  handleOpen = () => {
    this.setState({
      isOpen: true
    })
  };

  handleAddOption = (option, selected) => {
    const { onAddOption } = this.props;
    if (option) {
      onAddOption(option);
    }

    if (selected) {
      setTimeout(() => {
        this.handleChange(null, option);
      }, 100);
    }
  };

  getWidgetValue = (options, value) => {
    if (isString(value)) {
      value = parseInt(value);
    }
    return options.find(o => o.id === value) || null;
  }

  render() {
    const { isOpen } = this.state;
    const { options, loading, value, label, placeholder, size, disabled, textFieldProps, autocompleteProps } = this.props;
    const { dialogTitle, DialogComponent } = this.props;

    let widgetValue = value;
    if (value === undefined)
      widgetValue = null;

    if (widgetValue !== null) {
      if (isString(widgetValue) || isNumber(widgetValue)) {
        widgetValue = this.getWidgetValue(options, value);
      }
    }

    return (
      <React.Fragment>
        <StyledAutocomplete
          options={options}
          loading={loading}
          value={widgetValue}
          disabled={disabled}
          includeInputInList={true}
          getOptionSelected={this.handleOptionSelected}
          getOptionLabel={(option) => this.getOptionLabel(option)}
          onChange={(e, newValue) => this.handleChange(e, newValue)}
          size={size}
          noOptionsText={'Ничего не найдено'}
          selectOnFocus={true}
          autoHighlight={true}
          {...autocompleteProps}
          renderInput={(params) => {
            params.InputProps['endAdornment'] =
              <>
                {params.InputProps['endAdornment']}
                {widgetValue === null && DialogComponent && (
                  <InputAdornment position="end" style={{marginRight: '-33px'}}>
                    <IconButton size={'small'} onClick={() => this.handleOpen()}>
                      <AddOutlinedIcon />
                    </IconButton>
                  </InputAdornment>
                )}
              </>;
            return (
              <TextField
                {...params}
                variant="outlined"
                label={label}
                placeholder={placeholder}
                {...textFieldProps}
              />
            )
          }}
        />
        {widgetValue === null && DialogComponent && (
          <Dialog
            open={isOpen}
            onClose={() => this.handleClose()}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
          >
            <DialogTitle id="scroll-dialog-title">{dialogTitle}</DialogTitle>
            <DialogContent>
              {isOpen && (
                <DialogComponent
                  onClose={this.handleClose}
                  onAddOption={this.handleAddOption}
                />
              )}
            </DialogContent>
          </Dialog>
        )}
      </React.Fragment>
    )
  }
}

export const AsyncAutocompleteWidget = withAsync(AutocompleteWidget);
